import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ButtonData } from '../buttons/buttons.component';

export interface SectionCardInfoData {
  description: string;
  mainInfo: string;
  buttons: Array<ButtonData>;
  highlightText: string;
}

@Component({
  selector: 'fcp-section-card-info',
  templateUrl: './section-card-info.component.html',
  styleUrls: ['./section-card-info.component.scss']
})
export class SectionCardInfoComponent {

  @Input() public sectionCardInfo: SectionCardInfoData;
  @Output() public clicked: EventEmitter<any> = new EventEmitter();

  public emitClick(modal: string): void {
    this.clicked.emit(modal);
  }

}
